"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const ring_png_1 = __importDefault(require("../../assets/img/ring.png"));
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-21560052"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bgc" }, null, -1));
const _hoisted_2 = { class: "productionInfo" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
    class: "ring",
    src: ring_png_1.default,
    alt: ""
}, null, -1));
const _hoisted_4 = { class: "SN" };
const _hoisted_5 = { class: "SN" };
const index_vue_1 = __importDefault(require("./Flow/index.vue"));
const index_vue_2 = __importDefault(require("./Drawer/index.vue"));
const vue_3 = require("vue");
const index_1 = require("../../service/index");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const serialNumber = (0, vue_3.ref)(""); //用户搜到并选择的产品SN码或桩二维码
        const SN = (0, vue_3.ref)(""); //产品SN码
        const stakeQRCode = (0, vue_3.ref)(""); //桩二维码
        const drawerOpen = (0, vue_3.ref)(false);
        const baseInfo = (0, vue_3.ref)([]); //基础信息数据
        const nodesEnum = (0, vue_3.ref)({}); //节点枚举对象
        const model = (0, vue_3.ref)('base'); //打开drawer时的模式，base表示点击基本信息，node表示点击节点
        const drawerTitle = (0, vue_3.ref)('基本信息');
        //点击通过用户选择的SN码或者桩二维码（即serialNumber）查询基本信息，弹出基本信息drawer，并获得基本信息中的SN码和桩二维码保存起来。
        const showBaseInfo = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (serialNumber.value !== "") {
                const res = yield (0, index_1.getBaseInfo)(serialNumber.value);
                drawerOpen.value = true;
                model.value = 'base';
                drawerTitle.value = '基本信息';
                baseInfo.value = res.data;
                //获得SN码并保存
                SN.value = (_a = res.data.find((item) => (item === null || item === void 0 ? void 0 : item.label) === '产品SN码')) === null || _a === void 0 ? void 0 : _a.value;
                //获得桩二维码并保存
                stakeQRCode.value = (_b = res.data.find((item) => (item === null || item === void 0 ? void 0 : item.label) === '桩二维码')) === null || _b === void 0 ? void 0 : _b.value;
            }
        });
        //点击节点弹出drawer
        const showNodeInfo = (data) => __awaiter(this, void 0, void 0, function* () {
            if (SN.value !== "" && nodesEnum.value) {
                let enumData = '';
                //针对两个“发货” 和 场站上线做特殊处理
                if (data.label === '发货') {
                    enumData = 'C5';
                }
                else if (data.label === '设备上线') {
                    enumData = 'D6';
                }
                else {
                    for (const key in nodesEnum.value) {
                        if (nodesEnum.value[key] === data.label) {
                            enumData = key;
                        }
                    }
                }
                const res = yield (0, index_1.searchNodeInfo)(SN.value, enumData);
                model.value = 'node';
                drawerTitle.value = data.label;
                drawerOpen.value = true;
                baseInfo.value = res.data;
            }
        });
        const backToProdInfo = () => {
            router.push({
                path: '/productionInfo',
                query: {
                    chengpinsnma: SN.value,
                    stakeQRCode: stakeQRCode.value,
                }
            });
        };
        (0, vue_3.onMounted)(() => __awaiter(this, void 0, void 0, function* () {
            var _c, _d;
            const res = yield (0, index_1.getNodesEnum)();
            if (res === null || res === void 0 ? void 0 : res.data) {
                nodesEnum.value = res.data;
            }
            if (((_c = route.query) === null || _c === void 0 ? void 0 : _c.SN) || ((_d = route.query) === null || _d === void 0 ? void 0 : _d.stakeQRCode)) {
                SN.value = route.query.SN;
                stakeQRCode.value = route.query.stakeQRCode;
                serialNumber.value = route.query.SN;
            }
            showBaseInfo();
        }));
        return (_ctx, _cache) => {
            const _component_Header = (0, vue_2.resolveComponent)("Header");
            const _component_a_button = (0, vue_2.resolveComponent)("a-button");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                (0, vue_2.createVNode)(_component_Header),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("span", _hoisted_4, "产品SN码：" + (0, vue_2.toDisplayString)(SN.value || '--'), 1),
                    (0, vue_2.createElementVNode)("span", _hoisted_5, "桩二维码：" + (0, vue_2.toDisplayString)(stakeQRCode.value || '--'), 1),
                    (0, vue_2.createVNode)(_component_a_button, {
                        class: "btn",
                        onClick: showBaseInfo
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)("基础信息")
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_a_button, {
                        class: "btn",
                        onClick: backToProdInfo
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)("返回卡片视图")
                        ]),
                        _: 1
                    })
                ]),
                (0, vue_2.createVNode)(index_vue_1.default, { onGetClickNodeData: showNodeInfo }),
                (0, vue_2.createVNode)(index_vue_2.default, {
                    open: drawerOpen.value,
                    "onUpdate:open": _cache[0] || (_cache[0] = ($event) => ((drawerOpen).value = $event)),
                    title: drawerTitle.value,
                    baseInfo: baseInfo.value,
                    model: model.value
                }, null, 8, ["open", "title", "baseInfo", "model"])
            ], 64));
        };
    }
});
